import {
  faSyncAlt,
  faCalendarAlt,
  faLeaf,
  faSeedling,
  faCheckCircle,
  faHourglass,

  faFileAlt,
  faFileExport,

  faUser,
  faFilter,
  faTimes,
  faDownload
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DataTable from "components/DataTable";
import GenericModal from "components/Modal";
import React, { ReactNode, useEffect, useState, useMemo, useCallback, useRef } from "react";
import ActionsCell from "./ActionsCell";
import httpClient from "services/network/httpClient";
import { epochToDate } from "utility/dateFormat";


import { motion } from "framer-motion";
import DemoFilter from "./DemoFilter";
import ViewDetails from "./ViewDetails";
import { exportToExcel, ExportColumn } from "utility/exportToExcel";
import { VisitData } from "./completedDemo";
import appConfig from "services/config";
import axios from "axios";
import DemoReportFilter, { FilterFormValues } from "pages/summary/demo/DemoReportFilter";
import FilterBadge, { FilterChip } from "components/filter/FilterBadge";
import { getFileNameFromDisposition } from "pages/summary/VisitReport";
import { getDefaultDateRange } from "pages/report/ReportList";
import CustomButton from "components/button/CustomButton";
import DateTimeCell from "components/DataTable/DateTimeCell";
import { msToDateInput } from "../../summary/DemoReport"
import FollowUpDateTimeCell from "components/DataTable/FolloUpDateTimeCell";

// Utility to convert ms/epoch to YYYY-MM-DD string for input fields and chips
// function msToDateInput(ms?: string | number): string {
//   if (!ms) return "";
//   const msNum = typeof ms === "string" ? parseInt(ms, 10) : ms;
//   const d = new Date(msNum < 1e12 ? msNum * 1000 : msNum);
//   return d.toISOString().slice(0, 10);
// }

interface EmployeeTaskProps {
  employeeId: string;
  firstName: string;
  city: string;
  completedDemo: number;
  pending: number;
}



interface CompleteDemoProps {
  viewData?: EmployeeTaskProps | null;
  isShowHeaders?: boolean; // Optional prop to control header visibility
  onStatsUpdate?: (completedCount: number, pendingCount: number) => void;
  onTodayDemoUpdate?: (todayDemos: VisitData[]) => void;
  isFiltered?: string; // Prop to indicate if data is filtered
}

const ProductNamesCell: React.FC<{ value: unknown }> = ({ value }) => {
  const products = value as Array<{ id: number; name: string }>;

  if (!products || products.length === 0) {
    return (
      <div className="flex items-center">
        <span className="text-gray-500 dark:text-gray-400 italic">No products</span>
      </div>
    );
  }

  if (products.length === 1) {
    return (
      <div className="flex items-center">
        <span className="text-gray-700 dark:text-gray-300">{products[0].name}</span>
      </div>
    );
  }

  return (
    <div className="flex items-start">

      <div className="flex flex-col gap-1">
        {products.map((product, index) => (
          <span
            key={product.id || index}
            className="text-gray-700 dark:text-gray-300 text-sm  dark:bg-emerald-900/20 rounded"
          >
            {product.name}
          </span>
        ))}
      </div>
    </div>
  );
};

const CompleteDemo = ({ viewData, isShowHeaders = true, onStatsUpdate, onTodayDemoUpdate, isFiltered }: CompleteDemoProps) => {
  const [visits, setVisits] = useState<VisitData[]>([]);
  const [url, setUrl] = useState(`complete`);
  const [selectedVisit, setSelectedVisit] = useState<VisitData | null>(null);
  const [isView, setIsView] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [todayDemoList, setTodayDemoList] = useState<VisitData[]>([]);
  const [showFilter, setShowFilter] = useState(false);
  const [filterBtnRef, setFilterBtnRef] = useState<HTMLButtonElement | null>(null);
  const [crops, setCrops] = useState<Array<{ id: number, name: string }>>([]);
  const [products, setProducts] = useState<Array<{ id: number, name: string }>>([]);
  const [activeFilters, setActiveFilters] = useState<Record<string, any>>({});
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isClear, setIsClear] = useState(true);
  const [activeFilterFormValues, setActiveFilterFormValues] = useState<Partial<FilterFormValues>>({});
  const [filterChips, setFilterChips] = useState<FilterChip[]>([]);
  const activeParamsRef = useRef<Record<string, string>>({});
  const [isDownloading, setIsDownloading] = useState(false);

  console.log(todayDemoList);

  // const getCurrentMonthDates = () => {
  //   const now = new Date();
  //   const year = now.getFullYear();
  //   const month = now.getMonth();


  //   const fromDateStr = `${year}-${String(month + 1).padStart(2, '0')}-01`;

  //   // Last day of current month
  //   const lastDay = new Date(year, month + 1, 0).getDate();
  //   const toDateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;

  //   return { fromDateStr, toDateStr };
  // };

  const normalizeData = (resp: any, url: string) => {
    // API sometimes returns results as resp.value.contents (paged)
    // or as resp.value.content or as resp.value (direct array). Prefer detecting the shape.
    if (Array.isArray(resp?.value?.contents)) {
      return resp.value.contents;
    }
    if (Array.isArray(resp?.value?.content)) {
      return resp.value.content;
    }
    if (Array.isArray(resp?.value)) {
      return resp.value;
    }
    if (Array.isArray(resp?.contents)) {
      return resp.contents;
    }
    if (Array.isArray(resp?.content)) {
      return resp.content;
    }
    return [];
  };

  const addMissingDates = (params: URLSearchParams) => {
    if (!params.has("fromDate") || !params.has("toDate")) {
      // const { fromDateStr, toDateStr } = getCurrentMonthDates();
      const { fromDate, toDate } = getDefaultDateRange();
      if (!params.has("fromDate")) {
        params.set("fromDate", `${fromDate}`);
      }
      if (!params.has("toDate")) {
        params.set("toDate", `${toDate}T23:59:59Z`);
      }
    }
  };

  const buildFilteredUrl = (isFiltered: string, defaultStatus: string, baseApi: string): string => {
    const params = new URLSearchParams(isFiltered);
    params.delete("status");
    params.set("status", defaultStatus);
    addMissingDates(params);
    params.set("page", String(pageNumber));
    params.set("size", String(itemsPerPage));
    return `${baseApi}?${params.toString()}`;
  };

  // Helper function to build URL parameters from active filters
  const appendFilterParamsToURLSearchParams = (
    params: URLSearchParams,
    activeFilters: Record<string, any>,
    defaultStatus: string,
    includePagination: boolean
  ): void => {
    const addSelect = (key: string) => {
      const v = activeFilters[key];
      if (v && typeof v === "object" && "value" in v) {
        params.append(key, String(v.value));
      }
    };

    ["productId", "cropId", "status", "month", "year"].forEach(addSelect);

    if (activeFilters.fromDate) params.append("fromDate", `${activeFilters.fromDate}`);
    if (activeFilters.toDate) params.append("toDate", `${activeFilters.toDate}`);
    if (!params.has("status")) params.append("status", defaultStatus);

    if (includePagination) {
      params.append("page", String(pageNumber));
      params.append("size", String(itemsPerPage));
    }
  };

  const buildActiveFiltersUrl = (activeFilters: Record<string, any>, defaultStatus: string, baseApi: string): string => {
    const params = new URLSearchParams();
    appendFilterParamsToURLSearchParams(params, activeFilters, defaultStatus, true);
    const s = params.toString();
    return s.length ? `${baseApi}?${s}` : baseApi;
  };

  const buildDefaultUrl = (defaultStatus: string, baseApi: string): string => {
    const { fromDate, toDate } = getDefaultDateRange();
    return `${baseApi}?status=${defaultStatus}&fromDate=${fromDate}&toDate=${toDate}&page=${pageNumber}&size=${itemsPerPage}`;
  };

  const fetchDemoData = async () => {
    setIsLoading(true);

    const baseApi = `product-demo/complete/${viewData?.employeeId}`;
    const defaultStatus = url === "pending" ? "true" : "false";

    const buildApiUrl = (): string => {
      if (isFiltered && isFiltered.length > 0) {
        return buildFilteredUrl(isFiltered, defaultStatus, baseApi);
      }

      if (Object.keys(activeFilters).length > 0) {
        return buildActiveFiltersUrl(activeFilters, defaultStatus, baseApi);
      }

      return buildDefaultUrl(defaultStatus, baseApi);
    };

    const apiUrl = buildApiUrl();
    console.log("Using API URL:", apiUrl);

    try {
      if (isClear) {
        const resp: any = await httpClient.get(apiUrl);
        const normalizedData = normalizeData(resp, url);
        console.log("Fetched demo data:", normalizedData);
        console.log(`Total demos fetched for ${url}:`, normalizedData.length);
        setVisits(normalizedData);
        // Set total items for pagination
        setTotalItems(resp?.value?.totalElements || normalizedData.length);

        const todayList = normalizedData.filter((visit: VisitData) =>
          epochToDate(visit.createdDate) === epochToDate(Date.now())
        );

        setTodayDemoList(todayList);
        if (onTodayDemoUpdate) onTodayDemoUpdate(todayList);

        if (onStatsUpdate) {
          await updateStats(normalizedData, todayList);
        }
      }
    } catch (error) {
      console.error("Error fetching demo data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateStats = async (normalizedData: VisitData[], todayList: VisitData[]) => {
    const baseApi = `product-demo/complete/${viewData?.employeeId}`;

    const getListByStatus = async (statusVal: string) => {
      try {
        const r: any = await httpClient.get(`${baseApi}?status=${statusVal}`);
        return Array.isArray(r.value?.content) ? r.value.content : [];
      } catch {
        return null;
      }
    };

    if (url === "complete") {
      const completedCount = normalizedData.length;
      const pendingData = await getListByStatus("true");

      if (pendingData === null) {
        onStatsUpdate?.(completedCount, viewData?.pending ?? 0);
        return;
      }

      const pendingTodayList = pendingData.filter((visit: VisitData) =>
        epochToDate(visit.createdDate) === epochToDate(Date.now())
      );
      const allTodayDemos = [...todayList, ...pendingTodayList];
      console.log("Complete tab: Today's demos combined:", allTodayDemos.length, {
        completed: todayList.length,
        pending: pendingTodayList.length,
      });
      setTodayDemoList(allTodayDemos);
      onTodayDemoUpdate?.(allTodayDemos);
      onStatsUpdate?.(completedCount, pendingData.length);
      return;
    }

    const pendingCount = normalizedData.length;
    const completeData = await getListByStatus("false");

    if (completeData === null) {
      onStatsUpdate?.(viewData?.completedDemo ?? 0, pendingCount);
      return;
    }

    onStatsUpdate?.(completeData.length, pendingCount);
    const completedTodayList = completeData.filter((visit: VisitData) =>
      epochToDate(visit.createdDate) === epochToDate(Date.now())
    );
    const allTodayDemos = [...todayList, ...completedTodayList];
    console.log("Pending tab: Today's demos combined:", allTodayDemos.length, {
      pending: todayList.length,
      completed: completedTodayList.length,
    });
    setTodayDemoList(allTodayDemos);
    onTodayDemoUpdate?.(allTodayDemos);
  };

  useEffect(() => {
    if (viewData?.employeeId) {
      fetchDemoData();
      fetchFilterData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewData?.employeeId, url, pageNumber, itemsPerPage]);

  const fetchFilterData = () => {
    // Fetch crops data
    httpClient
      .get("crop/all?page=1&size=2000")
      .then((res: any) => {
        console.log("Crops data for filter:", res);
        if (res.value.contents && Array.isArray(res.value.contents)) {
          setCrops(res.value.contents.map((crop: any) => ({
            id: crop.id,
            name: crop.cropName
          })));
        }
      })
      .catch((error) => {
        console.error("Error fetching crops data:", error);
      });

    // Fetch products data
    httpClient
      .get("product/all?page=1&size=2000")
      .then((res: any) => {
        console.log("Products data for filter:", res);
        if (res.value.contents && Array.isArray(res.value.contents)) {
          setProducts(res.value.contents.map((product: any) => ({
            id: product.id,
            name: product.productName
          })));
        }
      })
      .catch((error) => {
        console.error("Error fetching products data:", error);
      });
  };

  const handleFilterSubmit = (filterData: any) => {
    console.log("Filter data submitted:", filterData);

    const params: Record<string, string> = {};
    if (filterData.fromDate) params.fromDate = `${filterData.fromDate}`;
    if (filterData.toDate) params.toDate = `${filterData.toDate}`;
    if (filterData.manager && filterData.manager !== "All") params.managerId = filterData.manager;
    if (filterData.employee && filterData.employee !== "All") params.empIds = filterData.employee;
    if ((filterData as any).product && (filterData as any).product !== "All") params.productId = (filterData as any).product;
    if ((filterData as any).crop && (filterData as any).crop !== "All") params.cropId = (filterData as any).crop;
    if ((filterData as any).distributor && (filterData as any).distributor !== "All") params.distributor = (filterData as any).distributor;

    // Always enforce status based on active tab: complete → 0, pending (follow-up) → 1
    params.status = url === "pending" ? "1" : "0";

    // Store active filters
    activeParamsRef.current = params;
    setActiveFilters(params);
    // Always store as string for popup
    setActiveFilterFormValues({
      ...filterData,
      fromDate: msToDateInput(params.fromDate),
      toDate: msToDateInput(params.toDate),
    });

    // Build filter chips
    const chips: FilterChip[] = [];
    if (params.fromDate || params.toDate) {
      chips.push({
        id: "dateRange",
        label: `Date: ${msToDateInput(params.fromDate)} – ${msToDateInput(params.toDate)}`,
        onRemove: () => removeChip("dateRange", ["fromDate", "toDate"], ["fromDate", "toDate"]),
      });
    }
    if (params.managerId) {
      chips.push({
        id: "manager",
        label: `Manager: ${filterData.__managerLabel ?? params.managerId}`,
        onRemove: () => removeChip("manager", ["managerId"], ["manager"]),
      });
    }
    if (params.empIds) {
      chips.push({
        id: "employee",
        label: `Employee: ${filterData.__employeeLabel ?? params.empIds}`,
        onRemove: () => removeChip("employee", ["empIds"], ["employee"]),
      });
    }
    if (params.productId) {
      chips.push({
        id: "product",
        label: `Product: ${filterData.__productLabel ?? params.productId}`,
        onRemove: () => removeChip("product", ["productId"], ["product"]),
      });
    }
    if (params.cropId) {
      chips.push({
        id: "crop",
        label: `Crop: ${filterData.__cropLabel ?? params.cropId}`,
        onRemove: () => removeChip("crop", ["cropId"], ["crop"]),
      });
    }
    setFilterChips(chips);

    // Reset to first page when applying filters
    setPageNumber(1);

    console.log("Filter params:", params.toString());

    // Call API with filters
    setIsLoading(true);
    httpClient
      .get(`product-demo/complete/${viewData?.employeeId}?${new URLSearchParams(params).toString()}`)
      .then((resp: any) => {
        const normalizedData = normalizeData(resp, url);
        setVisits(normalizedData);
        setTotalItems(resp?.value?.totalElements || normalizedData.length);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching filtered data:", error);
        setIsLoading(false);
      });

    // Close filter form
    setShowFilter(false);
  };

  const removeChip = (chipId: string, paramKeys: string[], formKeys: string[]) => {
    // Read from ref — always current even in stale closures
    const newParams = { ...activeParamsRef.current };
    if (chipId === "dateRange") {
      const { fromDate, toDate } = getDefaultDateRange();
      newParams.fromDate = `${fromDate}`;
      newParams.toDate = `${toDate}`;
    } else {
      paramKeys.forEach(k => delete newParams[k]);
    }
    setFilterChips(prev => prev.filter(c => c.id !== chipId));
    activeParamsRef.current = newParams;
    setActiveFilters(newParams);
    setActiveFilterFormValues(prev => {
      const next = { ...prev } as any;
      // Always store as string for popup
      next.fromDate = msToDateInput(newParams.fromDate);
      next.toDate = msToDateInput(newParams.toDate);
      formKeys.forEach(k => { if (k !== "fromDate" && k !== "toDate") delete next[k]; });
      return next;
    });
    setIsLoading(true);
    httpClient
      .get(`product-demo/complete/${viewData?.employeeId}?${new URLSearchParams(newParams).toString()}`)
      .then((resp: any) => {
        const normalizedData = normalizeData(resp, url);
        setVisits(normalizedData);
        setTotalItems(resp?.value?.totalElements || normalizedData.length);
      })
      .catch((error) => {
        console.error("Error fetching data after chip removal:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleFilterClose = () => {
    setShowFilter(false);
  };

  const resetFilters = () => {
    // Reset active filters
    activeParamsRef.current = {};
    setActiveFilters({});
    setActiveFilterFormValues({});
    setFilterChips([]);
    setIsClear(false);
    // Reset to first page
    setPageNumber(1);
    // Fetch data without filters
    setIsLoading(true);
    const defaultStatus = url === "pending" ? "true" : "false";
    // const { fromDateStr, toDateStr } = getCurrentMonthDates();
    const { fromDate, toDate } = getDefaultDateRange();
    httpClient
      .get(`product-demo/complete/${viewData?.employeeId}?status=${defaultStatus}&fromDate=${fromDate}&toDate=${toDate}&page=1&size=${itemsPerPage}`)
      .then((resp: any) => {
        const normalizedData = normalizeData(resp, url);
        setVisits(normalizedData);
        setTotalItems(resp?.value?.totalElements || normalizedData.length);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      });
  };


  const handleExportToExcel = async () => {
    const token = localStorage.getItem("accessToken");
    const baseUrl = appConfig.getBaseUrl();
    console.log("Base URl: ", baseUrl);

    // status=0 → completed tab, status=1 → follow-up (pending) tab
    const defaultStatus = url === "pending" ? "1" : "0";

    // Use active filter params if the user applied a filter, otherwise fall back to default date range
    const params: Record<string, string> = Object.keys(activeFilters).length > 0
      ? { ...activeFilters }
      : (() => {
        const { fromDate, toDate } = getDefaultDateRange();
        return { fromDate, toDate };
      })();

    // Always enforce the correct status based on the active tab
    params.status = defaultStatus;

    setIsDownloading(true);

    await axios.get(
      `${baseUrl}/product-demo/complete/team/export?empIds=${viewData?.employeeId}&${new URLSearchParams(params).toString()}`,
      {
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((response) => {
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        console.log("This is the Demo report resposne: ", response);
        const disposition = response.headers["content-disposition"];
        console.log("This is the demo excell file disposition: ", disposition);
        const fileName = getFileNameFromDisposition(disposition);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Generate Report error: ", error);
      })
      .finally(() => {
        setIsDownloading(false);
      })
  };
  const getActiveFilterCount = () => {
    return Object.keys(activeFilters).filter(key => {
      const value = activeFilters[key];

      // If the value doesn't exist or is null/undefined
      if (value === null || value === undefined) {
        return false;
      }

      // For react-select values (objects with value property)
      if (typeof value === 'object' && value !== null) {
        return value.value !== undefined &&
          value.value !== null &&
          value.value !== '';
      }

      // For simple values (like date strings), make sure they're not empty
      return value !== '';
    }).length;
  };

  const handleView = useCallback((row: VisitData) => {
    if (!row) {
      console.error("Attempted to view details for undefined row");
      return;
    }
    setIsView(true);
    setSelectedVisit(row);
  }, []);
  const handleDownload = useCallback((row: VisitData) => {
    if (!row) {
      console.error("Attempted to download details for undefined row");
      return;
    }
    const token = localStorage.getItem("accessToken");
    const baseUrl = appConfig.getBaseUrl();

    axios.get(`${baseUrl}/reports/demo/${row.id}/pdf`, {
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );
        const disposition = response.headers["content-disposition"];
        console.log("This is the vist excell response: ", response);
        console.log("THis is the Visit excell export disposition : ", disposition);
        const fileName = getFileNameFromDisposition(disposition);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Download PDF error: ", error);
      });
  }, []);

  const handleRefresh = () => {
    fetchDemoData();
  };

  // Since sorting is handled internally by the DataTable component,
  // we don't need to define a handleSort function here.
  // We'll just use the sortField and sortDirection states for other purposes.

  // Convert VisitData to the format expected by DataTable
  const formattedData = useMemo(() => {
    return visits.map(visit => {
      const row: any = {
        id: visit.id || 0,
        farmerName: visit.farmerName || '',
        cropName: visit.cropName || '',
        cultivatedAcres: visit.cultivatedAcres || '',
        productNames: visit.productNames || [],
        purchaseQuantity: visit.purchaseQuantity || 0,
        createdDate: visit.createdDate || 0,
        nextFollowUpDate: visit.nextFollowUpDate || null,
        location: `${visit.village || ''}, ${visit.district || ''}`,
        updatedDate: visit.updatedDate || 0,
        completedDate: visit.completedDate || 0,
        isPending: visit.isPending,
      };

      // Store the original data in a way that doesn't conflict with Row type
      row._originalData = visit;

      return row;
    });
  }, [visits]);

  // Filter data based on search term
  const filteredData = useMemo(() => {
    if (!searchTerm.trim()) {
      return formattedData;
    }

    const searchTermLower = searchTerm.toLowerCase();
    return formattedData.filter(row => {
      // Safely check each field, handling null or undefined values
      const farmerName = row.farmerName ? String(row.farmerName).toLowerCase() : '';
      const cropName = row.cropName ? String(row.cropName).toLowerCase() : '';
      const location = row.location ? String(row.location).toLowerCase() : '';

      // Search through productNames array
      const productNamesMatch = row.productNames && Array.isArray(row.productNames)
        ? row.productNames.some((product: any) =>
          product.name && String(product.name).toLowerCase().includes(searchTermLower)
        )
        : false;

      return farmerName.includes(searchTermLower) ||
        cropName.includes(searchTermLower) ||
        productNamesMatch ||
        location.includes(searchTermLower);
    });
  }, [formattedData, searchTerm]);

  // Since we removed the sortField and sortDirection states,
  // we'll just use the filteredData directly
  const sortedData = filteredData;

  const renderActions = useCallback((row: any) => <ActionsCell row={row} onView={handleView} onDownload={handleDownload} />, [handleView, handleDownload]);

  const hasFollowUp = sortedData?.some((row: any) => row?.isPending === false);

  const demoColumns = [
    {
      key: "farmerName",
      label: "Farmer Name",
      sortable: true,
      render: (value: ReactNode, row: any) => (
        <div className="flex items-center">

          <div>
            <div className="font-medium text-gray-800 dark:text-gray-200">{value || 'N/A'}</div>
            <div className="text-xs text-gray-500 dark:text-gray-400">
              {row?._originalData?.farmerContactNumber || 'No Contact'}
            </div>
          </div>
        </div>
      )
    },
    {
      key: "cropName",
      label: "Crop",
      sortable: true,
      render: (value: ReactNode) => (
        <div className="flex items-center">

          <span className="text-gray-700 dark:text-gray-300">{value}</span>
        </div>
      )
    },
    {
      key: "cultivatedAcres",
      label: "Acres",
      render: (value: ReactNode) => (
        <div className="bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-400 py-1 px-2 rounded-md text-center font-medium text-sm">
          {value}
        </div>
      )
    },
    {
      key: "productNames",
      label: "Products",
      sortable: true,
      render: (value: ReactNode) => <ProductNamesCell value={value} />
    },
    {
      key: "purchaseQuantity",
      label: "Purchase Qty",
      width: "1%",
      sortable: true,
      render: (value: ReactNode) => (
        <div className="bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400 rounded-md text-center font-medium text-sm">
          {value}
        </div>
      )
    },
    {
      key: "createdDate",
      label: "Created Date",
      render: (value: ReactNode) => (
        <DateTimeCell value={value as number} />
      )
    },

    //  if there is no follow-up date column will not display
    ...(hasFollowUp
      ? [
        {
          key: "completedDate",
          label: "Completed Date",
          render: (value: ReactNode) => (
            <DateTimeCell value={value as number} />
          )
        },
        {
          key: "nextFollowUpDate",
          label: "Follow Up",
          render: (value: ReactNode) => (
            <FollowUpDateTimeCell value={value as number} />
          )
        },
      ]
      : []),
    // {
    //   key: "updatedDate",
    //   label: "updatedDate Date",
    //   render: (value: ReactNode) => (
    //     <DateTimeCell value={value as number} />
    //   )
    // },

    {
      key: "actions",
      label: "Actions",
      excludeExport: true,
      actions: renderActions,
    },
  ];

  const handlePageChange = (newPage: number) => {
    setPageNumber(newPage);
  };

  const handleItemsPerPageChange = (newItemsPerPage: number) => {
    setItemsPerPage(newItemsPerPage);
    setPageNumber(1);
  };

  const activeFilterCount = getActiveFilterCount();
  let activeFilterLabel = "";
  if (isFiltered && isFiltered.length > 0) {
    activeFilterLabel = "Dashboard filters applied";
  } else {
    const suffix = activeFilterCount === 1 ? "" : "s";
    activeFilterLabel = `${activeFilterCount} active filter${suffix}`;
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="bg-white dark:bg-gray-800 rounded-lg shadow-sm"
    >
      {/* Tab Section */}
      <div className="flex flex-col md:flex-row md:items-center justify-between border-b border-gray-200 dark:border-gray-700 ">
        <div className="flex mb-4 md:mb-0">
          <motion.button
            whileHover={{ y: -2 }}
            whileTap={{ y: 0 }}
            onClick={() => setUrl("complete")}
            className={`px-4 py-2 font-medium text-sm md:text-base rounded-t-lg transition-all duration-200 flex items-center ${url === "complete"
              ? "text-green-700 dark:text-green-400 border-b-2 border-green-700 dark:border-green-400 bg-green-50 dark:bg-green-900/20"
              : "text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white"
              }`}
          >
            <FontAwesomeIcon icon={faCheckCircle} className="mr-2" />
            Completed
          </motion.button>
          <motion.button
            whileHover={{ y: -2 }}
            whileTap={{ y: 0 }}
            onClick={() => setUrl("pending")}
            className={`px-4 py-2 font-medium text-sm md:text-base rounded-t-lg transition-all duration-200 flex items-center ${url === "pending"
              ? "text-amber-700 dark:text-amber-400 border-b-2 border-amber-500 dark:border-amber-400 bg-amber-50 dark:bg-amber-900/20"
              : "text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white"
              }`}
          >
            <FontAwesomeIcon icon={faHourglass} className="mr-2" />
            Follow Up
          </motion.button>
        </div>

        <div className="flex items-center space-x-3">
          <div className="relative">
            <input
              type="text"
              placeholder="Search farmer, crop, location..."
              className="pl-10 pr-4 py-2 text-sm border dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 dark:focus:ring-green-400 focus:border-transparent bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
              onChange={(e) => setSearchTerm(e.target.value)}
            />

          </div>

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            ref={setFilterBtnRef as any}
            onClick={() => setShowFilter(!showFilter)}
            className="relative px-3 py-2 bg-indigo-50 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-400 rounded-lg hover:bg-indigo-100 dark:hover:bg-indigo-800/40 transition-colors duration-200 flex items-center"
          >
            <FontAwesomeIcon icon={faFilter} className="mr-1.5" />
            <span>Filter</span>
            {filterChips.length > 0 && (
              <span className="absolute -top-1.5 -right-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-indigo-600 text-[10px] text-white font-bold">
                {filterChips.length}
              </span>
            )}
          </motion.button>



          <CustomButton onClick={handleExportToExcel} loading={isDownloading}> {!isDownloading && <FontAwesomeIcon icon={faDownload} className="mr-1.5" />} Download</CustomButton>

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleRefresh}
            className="p-2 bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-400 rounded-lg hover:bg-green-100 dark:hover:bg-green-800/40 transition-colors duration-200 flex items-center"
          >
            <FontAwesomeIcon icon={faSyncAlt} className={isLoading ? "animate-spin" : ""} />
            <span className="ml-1 hidden md:inline">Refresh</span>
          </motion.button>
        </div>
      </div>

      {/* Filter dropdown positioned below the filter button */}
      {showFilter && filterBtnRef && (
        <div
          style={{
            position: 'absolute',
            zIndex: 50,
            right: '8rem',
            top: `${filterBtnRef.getBoundingClientRect().bottom + window.scrollY + 10}px`,
            width: '400px',
            maxWidth: 'calc(100vw - 2rem)'
          }}
        >

          <DemoReportFilter
            onSubmit={handleFilterSubmit}
            onClose={handleFilterClose}
            crops={crops}
            products={products}
            showCropField={true}
            showProductField={true}
            showManager={false}
            showEmployee={false}
            initialValues={activeFilterFormValues}
            title="Filter Demo Details"
          ></DemoReportFilter>
        </div>
      )}

      {/* Active Filters Indicator */}
      {filterChips.length > 0 && (
        <FilterBadge count={filterChips.length} onClear={resetFilters} chips={filterChips} />
      )}
      {filterChips.length === 0 && isFiltered && isFiltered.length > 0 && isClear && (
        <div className="px-4 py-2 bg-blue-50 dark:bg-blue-900/20 border-b border-blue-100 dark:border-blue-800">
          <div className="flex items-center text-blue-700 dark:text-blue-300 text-sm">
            <FontAwesomeIcon icon={faFilter} className="mr-2" />
            <span className="font-medium">Dashboard filters applied</span>
          </div>
        </div>
      )}

      {/* Stats Section */}
      {isShowHeaders && (
        <motion.div
          initial={{ y: -10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.3, delay: 0.1 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4"
        >
          <motion.div
            whileHover={{ y: -5, boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)" }}
            className="bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/30 dark:to-blue-800/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800"
          >
            <div className="flex items-center">
              <div className="p-3 bg-blue-500/10 rounded-full mr-3">
                <FontAwesomeIcon icon={faFileAlt} className="text-blue-600 dark:text-blue-400" />
              </div>
              <div>
                <h3 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">Total Demos</h3>
                <p className="text-2xl font-bold text-blue-800 dark:text-blue-200">{totalItems}</p>
              </div>
            </div>
          </motion.div>

          <motion.div
            whileHover={{ y: -5, boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)" }}
            className="bg-gradient-to-br from-green-50 to-green-100 dark:from-green-900/30 dark:to-green-800/20 p-4 rounded-lg border border-green-200 dark:border-green-800"
          >
            <div className="flex items-center">
              <div className="p-3 bg-green-500/10 rounded-full mr-3">
                <FontAwesomeIcon icon={faSeedling} className="text-green-600 dark:text-green-400" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-green-700 dark:text-green-300 mb-1">Total Acres</h3>
                <p className="text-2xl font-bold text-green-800 dark:text-green-200 truncate" title={visits.reduce((sum, visit) => sum + (parseFloat(String(visit.cultivatedAcres || "0").replace(/,/g, "")) || 0), 0).toFixed(2)}>
                  {visits.reduce((sum, visit) => sum + (parseFloat(String(visit.cultivatedAcres || "0").replace(/,/g, "")) || 0), 0).toFixed(2)}
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            whileHover={{ y: -5, boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)" }}
            className="bg-gradient-to-br from-amber-50 to-amber-100 dark:from-amber-900/30 dark:to-amber-800/20 p-4 rounded-lg border border-amber-200 dark:border-amber-800"
          >
            <div className="flex items-center">
              <div className="p-3 bg-amber-500/10 rounded-full mr-3">
                <FontAwesomeIcon icon={faLeaf} className="text-amber-600 dark:text-amber-400" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-amber-700 dark:text-amber-300 mb-1">Total Purchase</h3>
                <p className="text-2xl font-bold text-amber-800 dark:text-amber-200 truncate">
                  {visits.reduce((sum, visit) => sum + (visit.purchaseQuantity || 0), 0)}
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}

      {/* Loading indicator */}
      {isLoading && (
        <div className="flex justify-center items-center py-8">
          <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-green-500"></div>
          <span className="ml-3 text-gray-600 dark:text-gray-300 font-medium">Loading data...</span>
        </div>
      )}

      {/* No Data State */}
      {!isLoading && visits.length === 0 && (
        <div className="flex flex-col items-center justify-center py-16">
          <div className="w-24 h-24 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center mb-4">
            <FontAwesomeIcon icon={url === "complete" ? faCheckCircle : faHourglass} className="text-4xl text-gray-400 dark:text-gray-500" />
          </div>
          <h3 className="text-xl font-medium text-gray-700 dark:text-gray-300 mb-2">No demos found</h3>
          <p className="text-gray-500 dark:text-gray-400 max-w-md text-center">
            {url === "complete"
              ? "There are no completed demos to display yet."
              : "There are no pending demos to display at this time."}
          </p>
        </div>
      )}

      {/* Data Table */}
      {!isLoading && visits.length > 0 && (
        <div className="p-4">
          <DataTable
            columns={demoColumns}
            data={sortedData}
            isAddBtnTrue={false}
            isSearchBtn={false}
            isExport={true}
            serverSide={true}
            currentPage={pageNumber}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            onPageChange={handlePageChange}
            onItemsPerPageChange={handleItemsPerPageChange}
          />
        </div>
      )}

      {/* View Details Modal */}
      {isView && selectedVisit && (
        <GenericModal
          isOpen={isView}
          onClose={() => setIsView(false)}
          header={`${selectedVisit.farmerName} Details`}
          size="xl"
          customHeight="90vh"
          customWidth="md:max-w-5xl"
        >
          <ViewDetails viewDetails={selectedVisit as any}
            onDeleteSuccess={fetchDemoData} onClose={() => setIsView(false)} />
        </GenericModal>
      )}
    </motion.div>
  );
};

export default CompleteDemo;